import React from 'react';
import type { EntryPointProps } from 'react-relay';
import { LoomPanel as Panel } from './main.tsx';

const LoomPanel = ({ props }: EntryPointProps<{}, {}, {}, {}>) => <Panel {...props} />;

export default LoomPanel;
